import { render, staticRenderFns } from "./HeaderDesktop.vue?vue&type=template&id=3a4c0539&scoped=true&"
import script from "./HeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./HeaderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HeaderDesktop.vue?vue&type=style&index=0&id=3a4c0539&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4c0539",
  null
  
)

export default component.exports